export * as LiteralEnum from "./literal-enum.js";
